import type { Router } from "@core/Api/Router";
import type ApiUrlCreator from "@core-ui/ApiServices/ApiUrlCreator";
import initEnterprise from "@ext/enterprise/utils/initEnterprise";
import { cachedSettingsStore } from "@ext/settings/logic/cachedSettingsStore";

const initEnterpriseCloud = async (_router: Router, apiUrlCreator: ApiUrlCreator) => {
	const userSettings = await initEnterprise(
		apiUrlCreator.getAddEnterpriseCloudWorkspaceUrl(),
		apiUrlCreator.getCloneEnterpriseCatalogsUrl(),
	);

	// Settings are hydrated once per page mount, so the endpoint written by addWorkspace needs pushing to the client.
	const webEditorUrl = userSettings?.workspace.webEditorUrl;
	if (webEditorUrl) cachedSettingsStore.getState().set("services.web-editor.endpoint", webEditorUrl);
};

export default initEnterpriseCloud;
